import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class EnvironmentService {
    private window: Window;

    constructor(@Inject(DOCUMENT) private document: Document) {
        this.window = this.document.defaultView;
    }

    getEnvironment() {
        const is_desenv = this.window.location.pathname.includes('/dev/');
        const is_localhost = this.window.location.host.includes('localhost');
        if (is_localhost) return 'sume-localhost';
        else if (is_desenv) return 'sume-desenvolvimento';
        else return 'sume-producao';
    }
}
